import type {
  SearchFilterConditionDate,
  SearchFilterField,
} from 'lib-shared-types-api';

import { dateFilterFields } from '../../components/filters/utils/definitions';

/** Checks if the given field is a date field. */
export const isDateFilterField = (
  field: SearchFilterField,
): field is SearchFilterConditionDate['field'] =>
  dateFilterFields.includes(field as SearchFilterConditionDate['field']);
